export default "__VITE_ASSET__CYJT3Jje__"